<template>
  <span>
    <div
      class="login-bg"
      :style="{
        backgroundImage:
          'url(' + require(`@/assets/img/background_login.svg`) + ')',
        height: '100vh',
      }"
    ></div>
    <v-row>
      <v-col cols="5" class="absolute-left">
        <ValidationObserver ref="observer">
          <v-card class="rounded-card">
            <v-card-text>
              <v-row>
                <v-col>
                  <v-img
                    class="custom-logo-position"
                    max-height="31"
                    max-width="86"
                    src="../../assets/img/logo_pln_login.svg"
                  ></v-img>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <p>
                    <span class="page-title">Login</span>
                    <span class="page-subtitle"
                      >Silahkan login terlebih dahulu untuk masuk aplikasi</span
                    >
                  </p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="1"></v-col>
                <v-col cols="10">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Email"
                    rules="required|email"
                  >
                    <div class="label">Email</div>
                    <v-text-field
                      v-model="input.email"
                      label="Email"
                      solo
                      flat
                      outlined
                      color="#2671D9"
                      class="custom-text-field"
                      :class="{ 'error--text': errors.length > 0 }"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Kata Sandi"
                    rules="required"
                  >
                    <div class="label">Password</div>
                    <v-text-field
                      v-model="input.password"
                      label="Password"
                      solo
                      flat
                      outlined
                      :type="type"
                      :append-icon="append_icon"
                      color="#2671D9"
                      class="custom-text-field"
                      @click:append="togglePassword"
                      :class="{ 'error--text': errors.length > 0 }"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                  <div style="margin: 50px 0px 20px 0px">
                    <div id="show_img_here" class="captcha"></div>
                  </div>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Captcha"
                    rules="required"
                  >
                    <v-text-field
                      prepend-icon="mdi mdi-refresh"
                      v-model="input.captcha_confirmation"
                      label="captcha"
                      type="text"
                      :error-messages="errors"
                      @click:prepend="generatCaptcha(1500)"
                    ></v-text-field>
                  </ValidationProvider>
                  <v-btn
                    depressed
                    color="#2671D9"
                    dark
                    width="100%"
                    style="margin-top: 30px"
                    @click="validateFormLogin"
                  >
                    MASUK KE APLIKASI
                  </v-btn>
                </v-col>
                <v-col cols="1"></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </ValidationObserver>
      </v-col>
      <v-col cols="7">
        <v-img
          class="custom-logo-position2"
          src="../../assets/img/logo-chargin-white.svg"
        ></v-img>
        <span class="login-title">Dashboard SPKLU</span>
        <span class="login-subtitle">Aplikasi Monitoring SPKLU</span>
      </v-col>
    </v-row>
  </span>
</template>
<script>
import AuthService from "@/services/default/AuthService";
import { StorageService } from "@/services/storage.service";
import ApiService from "@/services/api.service";
// import Loader from '@/components/Loader'
// import CryptoJS from 'crypto-js'
import { ValidationObserver, ValidationProvider } from "vee-validate";
import alert from "@/commons/helper/alert.helper";

const authService = AuthService.build();

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  name: "Login2",
  data() {
    return {
      input: {
        email: "",
        password: "",
        captcha: "",
        captcha_confirmation: "",
      },
      clickable: true,
      status: false,
      append_icon: "mdi-eye",
      type: "password",
      firstLoad: true,
    };
  },
  async created() {
    this.generatCaptcha(0);
  },
  computed: {},
  methods: {
    validateFormLogin() {
      const self = this;
      this.$refs.observer.validate().then((success) => {
        if (success) {
          if (self.input.captcha === self.input.captcha_confirmation) {
            self.loginUser();
          } else {
            alert.warning("Field captcha belum benar!");
          }
        }
      });
    },
    async loginUser() {
      const param = {
        username: this.input.email,
        password: this.input.password,
      };
      const response = await authService.login(param);

      if (response.data.success !== true) {
        this.isLoading = false;
        alert.failed(response.data.status + " - " + response.data.message);
      } else {
        const data = {
          // email: CryptoJS.AES.encrypt(response.data.email, 'ICON+SPKLUG20').toString(),
          // name: CryptoJS.AES.encrypt(response.data.name, 'ICON+SPKLUG20').toString(),
          // phone: CryptoJS.AES.encrypt(response.data.noHp, 'ICON+SPKLUG20').toString()
          email: response.data.data.email,
          name: response.data.data.fullName,
          username: response.data.data.username,
          phone: response.data.data.phone,
          role: response.data.data.role,
          companyId: response.data.data.company.idCompany,
          branch: response.data.data.branch,
        };

        const token = {
          token: response.data.data.jwtToken,
        };

        await StorageService.saveAuthdata(data, token);
        ApiService.setHeader();

        localStorage.setItem(
          "menu_status",
          JSON.stringify({
            menu_level: "level1",
            menu_parent_idx: undefined,
            menu_idx: 0,
          })
        );

        window.location = "dashboard/spklu";
        return true;
      }
    },
    generatCaptcha(milisec) {
      if (this.clickable === true) {
        this.clickable = false;
        window.setTimeout(() => {
          const chars =
            "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
          // You can include special characters by adding them to the string above, for eg: chars += "@#?<>";
          const length = 6;
          let ChangeCaptcha = "";
          for (let i = 0; i < length; i++) {
            const rnum = Math.floor(Math.random() * chars.length);
            ChangeCaptcha += chars.substring(rnum, rnum + 1);
          }
          this.input.captcha = ChangeCaptcha;
          this.clickable = true;

          const canvas = document.createElement("canvas");
          canvas.width = 300;
          canvas.height = 50;
          const ctx = canvas.getContext("2d");
          ctx.font = "30px Arial";
          const text = this.input.captcha;
          // ctx.fillText(text, 97, 35)
          ctx.strokeText(text, 95, 40);
          ctx.textAlign = "center";

          if (this.firstLoad) {
            const img = document.createElement("img");
            img.src = canvas.toDataURL();
            const src = document.getElementById("show_img_here");
            src.append(img);
            this.firstLoad = false;
          } else {
            // index 0 img array is bg, then get index 1
            const img = document.getElementsByTagName("img")[0];
            img.src = canvas.toDataURL();
          }
        }, milisec);
      }
    },
    togglePassword() {
      this.status = !this.status;
      if (this.status) {
        this.append_icon = "mdi-eye-off";
        this.type = "text";
      } else {
        this.append_icon = "mdi-eye";
        this.type = "password";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.rounded-card {
  border-radius: 0px 35px 35px 0px;
  /* height: 100%; */
  padding-bottom: 2%;
}

.absolute-left {
  padding-left: 0px !important;
  padding-top: 0px !important;
  left: 0;
  top: 0;
  position: absolute;
}

.absolute-right {
  padding-right: 0px !important;
  right: 0;
  position: absolute;
}

.label {
  color: #5979a6;
  font-weight: 600;
  font-size: 14px;
  margin: 0px 0px 8px 0px;
}

.page-title {
  font-weight: 700;
  font-size: 32px;
  color: #333333;
  margin: 3% 0% 2% 0%;
}

.page-subtitle {
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}

p span {
  display: block;
}

p {
  margin-left: 8%;
}

.custom-logo-position {
  margin: 3% 0% 0% 2%;
}

.custom-logo-position2 {
  margin: 3% 0% 0% 2%;
  right: 4%;
  top: -3%;
  position: absolute;
}

.captcha {
  border: 1px dotted #2671d9;
  /* padding: 5% 20% 5% 20%; */
  display: table;
  margin: 0 auto;
  background-image: url("../../assets/img/captcha-bg-2.jpg");
  letter-spacing: 10px;
  font-size: 20px;
  -webkit-text-stroke: 1px black;
  color: whitesmoke;

  /* disable select, copy and others on text */
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.login-title {
  font-weight: 700;
  font-size: 32px;
  color: #ffffff;
  letter-spacing: 0.12em;
  position: absolute;
  left: 45%;
  top: 44%;
}

.login-subtitle {
  font-weight: 400;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0.01em;
  position: absolute;
  left: 45%;
  top: 50%;
}

.login-bg {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  -webkit-filter: blur(3px);
  -moz-filter: blur(3px);
  -o-filter: blur(3px);
  -ms-filter: blur(3px);
  filter: blur(3px);
}
</style>
